/**
 * Legacy branding presets — the ONLY place with brand-specific code.
 *
 * These presets keep organizations working before their `customization.branding`
 * is seeded into the DB (and provide bundled logo/banner images until those are
 * hosted). Once an org has explicit branding with hosted image URLs, its preset
 * here is no longer used and can be deleted.
 *
 * Everything outside this file is brand-agnostic and reads `customization.branding`.
 */
import type { OrgBranding, OrgBrandingInput } from './orgBranding';
import rotaryDistrictLogo from '../assets/rotary-district-logo.png';

const ROTARY_PRESET: OrgBranding = {
    enabled: true,
    brandName: 'Rotary District 3291',
    tagline: 'CREATE LASTING IMPACT',
    subtagline: 'PEOPLE OF ACTION',
    logoUrl: rotaryDistrictLogo,
    // No bannerUrl: the "Create Lasting Impact" artwork was a colour reference,
    // not an asset to embed. Branding shows the logo + tagline text + theme.
    colors: {
        primary: '#005DAA',
        primaryDark: '#17458F',
        accent: '#F7A81B',
        textOnPrimary: '#ffffff'
    },
    themedReport: true
};

// Adamma had a colours-only accent theme (no logo/tagline/report theming).
const ADAMMA_PRESET: OrgBranding = {
    enabled: true,
    colors: {
        primary: '#FF5E20',
        primaryDark: '#545658',
        accent: '#F9A021',
        textOnPrimary: '#ffffff'
    },
    themedReport: false
};

const ROTARY_NAME_PATTERN = /rotar(y|t)/i;

/**
 * Resolve a legacy branding preset from an org's name or legacy customization
 * flag. Returns null when no legacy preset applies.
 */
export function legacyBranding(org?: OrgBrandingInput | null): OrgBranding | null {
    if (!org) return null;
    const name = org.name?.trim();
    if (org.customization?.rotaryBranding || (name && ROTARY_NAME_PATTERN.test(name))) {
        return ROTARY_PRESET;
    }
    if (name && name.toLowerCase() === 'adamma infoservices') {
        return ADAMMA_PRESET;
    }
    return null;
}
